import './style.scss'

const BoxLegal = () => (
    <div className="box-legal">
        <span>เงื่อนไขทางกฎหมาย</span>
        <span>{`ข้อมูลของคุณจะถูกรวบรวมโดย DIF BOOKING ผู้ควบคุมข้อมูล เพื่อวัตถุประสงค์ในการประมวลผลคำขอของคุณและเพื่อตอบสนอง
สำหรับคำถามของคุณ ข้อมูลของคุณจะถูกประมวลผลตามนโยบายคุ้มครองข้อมูลส่วนบุคคลของเรา คุณสามารถยกเลิกที่ใดก็ได้
ตลอดระยะเวลาใช้สิทธิ์ของคุณในการเข้าถึง การแก้ไข และการลบข้อมูลส่วนบุคคลของคุณโดยใช้แบบฟอร์มการติดต่อ`}</span>
    </div>
);

export default BoxLegal